import Vue from 'vue'
import store from '@/vuex'
import axios from 'axios'
import jsonlint from '@/assets/js/jsonlint'

let loadingCount = 0
let fullscreenLoading = null
let ContentType = 'Content-Type'
/**
 * 自定义请求拦截逻辑，可以处理权限，请求发送监控等
 * @param {Object} config
 */
export function requestSuccessFunc (config) {
  if (config.loading) {
    if (loadingCount === 0) {
      fullscreenLoading = Vue.prototype.$loading({
        lock: true,
        text: '读取数据中......'
      })
    }
    ++loadingCount
  }
  const UserId = sessionStorage.getItem('UserId')
  const EUserToken = sessionStorage.getItem('E-User-Token')
  const companyId = sessionStorage.getItem('companyId')
  const newHeaders = {
    'Content-Type': 'application/json;charset=utf-8',
    'Accept': '*/*',
    'UserId': UserId,
    'E-User-Token': EUserToken,
    'companyId': companyId
  }
  if (config.headers[ContentType]) {
    newHeaders[ContentType] = config.headers[ContentType]
  }
  config.headers = newHeaders

  let baseURL = config.baseURL
  if (config.isNewApi) {
    baseURL = baseURL.replace('portal/', '')
  }
  // if (config.url.indexOf('http') === -1) {
  config.url = baseURL + config.url
  // }

  if (config.url.indexOf('passrecord/selectRecord') !== -1 ||
    config.url.indexOf('visitor/selectVisitorInfomationList') !== -1 ||
    config.url.indexOf('visitor/getVisitorRecordByVisitorCodeAndVisitorTime') !== -1) {
    config.transformResponse = [function (data) {
      // 对 data 进行任意转换处理
      return jsonlint.parse(data)
    }]
  }

  return config
}

/**
 * 自定义发送请求失败逻辑，断网，请求发送监控等
 * @param {Object} requestError
 */
export function requestFailFunc (requestError) {
  return Promise.reject(requestError)
}

/**
 * 自定义响应成功逻辑，全局拦截接口，根据不同业务做不同处理，响应成功监控等
 * @param {Object} responseObj
 */
export function responseSuccessFunc (responseObj) {
  if (responseObj.config.loading) {
    --loadingCount
    if (loadingCount <= 0) {
      fullscreenLoading && fullscreenLoading.close()
      loadingCount = 0
    }
  }
  if (responseObj.config.codeHandleList) {
    let handleType = 0
    for (let codeTypeData of responseObj.config.codeHandleList) {
      if (responseObj.data.code === codeTypeData.code || codeTypeData.code === 'all') {
        handleType = codeTypeData.type
        break
      }
    }
    if (responseObj.data.code !== 0 && responseObj.data.code !== '0' && responseObj.data.code !== 'RESP0000' && responseObj.data.code !== 'AUTH0000' && responseObj.data.code !== 'SYS0000' && handleType === 0) {
      Vue.prototype.$message({
        showClose: true,
        message: responseObj.data.msg,
        type: 'error'
      })
      // token失效处理
      if (responseObj.data.code === 'AUTH8899') {
        store.dispatch('AutoLogout')
        window.vueApp.$router.push({ name: 'login' })
      }
    }
  }
  if (responseObj.config.errorOnCatch && responseObj.data.code !== 0 && responseObj.data.code !== '0' && responseObj.data.code !== 'RESP0000' && responseObj.data.code !== 'AUTH0000' && responseObj.data.code !== 'SYS0000') {
    const error = new Error()
    error.serverError = responseObj
    error.message = responseObj.data.msg
    return Promise.reject(error)
  }

  // TODO 临时拦截数据做处理，迭代2.7.9需求3、vpad设备从硬件能力平台同步到睿畅连（930智居交付）
  if (responseObj.config.url.indexOf('device/type') > -1) {
    if (responseObj.data.data.data.deviceModels) {
      for (const model of responseObj.data.data.data.deviceModels) {
        if (model.modelName === '西蒙vpad') {
          model.banAdd = true
          model.banDelete = true
        }
      }
    }
  } else if (responseObj.config.url.indexOf('device/find') > -1) {
    if (responseObj.data.data.data) {
      for (const device of responseObj.data.data.data) {
        if (device.deviceModel === '西蒙vpad') {
          device.banAdd = true
          device.banDelete = true
        }
      }
    }
  } else {
    // sonar规则校验语法必须else
  }

  return responseObj.data
  // let {code} = resData;

  // switch (code) {
  //     case 0: // 如果业务成功，直接进成功回调
  //         return resData.data;
  //     case 1111:
  //         // 如果业务失败，根据不同 code 做不同处理
  //         // 比如最常见的授权过期跳登录
  //         // 特定弹窗
  //         // 跳转特定页面等

  //         location.href = xxx; // 这里的路径也可以放到全局配置里
  //         return;
  //     default:
  //         // 业务中还会有一些特殊 code 逻辑，我们可以在这里做统一处理，也可以下方它们到业务层
  //         !responseObj.config.noShowDefaultError && GLOBAL.vbus.$emit('global.$dialog.show', resData.msg);
  //         return Promise.reject(resData);
  // }
}

/**
 * 响应失败，可根据 responseError.message 和 responseError.response.status 来做监控处理
 * @param {Object} responseError
 */
export function responseFailFunc (responseError) {
  if (!axios.isCancel(responseError) && responseError.config.loading) {
    --loadingCount
    if (loadingCount <= 0) {
      fullscreenLoading && fullscreenLoading.close()
      loadingCount = 0
    }
  }
  let errorCode = -1
  if (responseError && responseError.response) {
    errorCode = responseError.response.status
    switch (responseError.response.status) {
      case 400:
        responseError.message = '错误请求'
        break
      case 401:
        responseError.message = '未授权，请重新登录'
        break
      case 403:
        responseError.message = '拒绝访问'
        break
      case 404:
        responseError.message = '请求错误,未找到该资源'
        break
      case 405:
        responseError.message = '请求方法未允许'
        break
      case 408:
        responseError.message = '请求超时'
        break
      case 500:
        responseError.message = responseError.response.data.msg || '服务器端出错'
        break
      case 501:
        responseError.message = '网络未实现'
        break
      case 502:
        responseError.message = '网络错误'
        break
      case 503:
        responseError.message = '服务不可用'
        break
      case 504:
        responseError.message = '网络超时'
        break
      case 505:
        responseError.message = 'http版本不支持该请求'
        break
      default:
        if (responseError.response.data.msg) {
          responseError.message = responseError.response.data.msg
        } else {
          responseError.message = `连接错误${responseError.response.status}`
        }
    }
  } else {
    responseError.message = '连接到服务器失败'
  }
  if (!axios.isCancel(responseError) && responseError.config.codeHandleList) {
    let handleType = 0
    for (let codeTypeData of responseError.config.codeHandleList) {
      if (errorCode === codeTypeData.code || codeTypeData.code === 'all') {
        handleType = codeTypeData.type
        break
      }
    }
    if (handleType === 0) {
      Vue.prototype.$message({
        showClose: true,
        message: responseError.message,
        type: 'error'
      })
    }
  }
  return Promise.reject(responseError)
}



// WEBPACK FOOTER //
// ./src/config/axios.js